import React from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import './styles.scss';

const NotificationList = props => {
    const generateLinkText = type => {
        if (type === 'district') {
            return 'Gå till distriktet för att uppdatera';
        }

        if (type === 'unit') {
            return 'Gå till enheten';
        }

        return '';
    };

    const getDateText = (date) => {
        const now = new Date().toLocaleDateString('sv');
        let today = new Date();
        today.setDate(today.getDate() - 1);
        const yesterday = today.toLocaleDateString('sv');

        if (now === date) {
            return 'idag';
        }

        if (yesterday === date) {
            return 'igår'
        }

        return date;
    }

    return (
        <div className="notifications-list">
            <div className="notifications-list__inner">
                {props.notifications && props.notifications.notifications &&
                    <>
                        <ol className="notifications-list__list">
                            {props.notifications.notifications.map((item, i) => {
                                return (
                                    <li className={classNames({
                                        'notifications-list__list-item': true,
                                        'notifications-list__list-item--is-new': !item.hasBeenRead,
                                        'notifications-list__list-item--district': item.notificationType === 'district',
                                        'notifications-list__list-item--unit': true,//item.notificationType === 'Enhet',
                                        'notifications-list__list-item--search': item.notificationType === 'Enhetssök',
                                        'notifications-list__list-item--message': item.notificationType === 'message'
                                    })} key={`notification${i}`}>
                                        <div className="notifications-list__item-icon"></div>
                                        <div className="notifications-list__item-content">
                                            {item.message &&
                                                <h2 className="notifications-list__item-heading">{item.message}</h2>
                                            }
                                            {item.text &&
                                                <p className="notifications-list__item-text">{item.text}</p>
                                            }
                                            {item.units && item.units[0] &&
                                                <a className="notifications-list__item-link" href={`/unit/${item.units[0].delfiId}?notificationId=${item.notificationId}`}>{generateLinkText('unit')}</a>
                                            }
                                            {item.createdDate &&
                                                <span className="notifications-list__item-when">
                                                    {getDateText(new Date(item.createdDate).toLocaleDateString('sv'))}
                                                </span>
                                            }
                                        </div>
                                    </li>
                                );
                            })}
                        </ol>
                        {props.notifications.hasMore &&
                            <Link className="notifications-list__load-more" to={`?page=${parseInt(props.page)+1}`}>Ladda fler</Link>
                        }
                        
                    </>
                }
            </div>
        </div>
    );
};

export default NotificationList;